module.exports = __webpack_public_path__ + "media/images/icons/arrow_down-d44cffd3e026ef64996b2271a942cf23.svg";